const alphabet = '23456789ABDEGJKMNPQRVWXYZ';

export function generateId(length: number = 6): string {
	let id:string = '';

	for (let i:number = 0; i < length; i++) {
		id += alphabet.charAt(Math.floor(Math.random() * alphabet.length));
	}

	return id;
}
